import { fromJS } from 'immutable';
import * as types from '../constants';

const defaultState = fromJS({
  isSaveBar: false
});

const saveBarReducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.CHANGE_PRODUCTS_HISTORY_FIELD:
    case types.CHANGE_TRENDING_PRODUCT_FIELD:
    case types.CHANGE_TOP_DISCOUNT_SETTINGS:
    case types.CHANGE_TRENDING_PRODUCT_SETTINGS:
    case types.CHANGE_PRODUCTS_HISTORY_SETTINGS:
    case types.CHANGE_BEST_SELLING_SETTINGS:
    case types.CHANGE_TOP_DISCOUNT_FIELD:
    case types.CHANGE_BEST_SELLING_FIELD:
    case types.ADD_PRODUCT_TOP_DISCOUNT:
    case types.ADD_PRODUCT_BEST_SELLING:
    case types.REMOVE_PRODUCT_TOP_DISCOUNT:
    case types.REMOVE_PRODUCT_BEST_SELLING:
    case types.CHANGE_LAYOUT_TYPE_THEME:
    case types.CHANGE_PRODUCTS_HISTORY_THEME:
    case types.CHANGE_BEST_SELLING_THEME:
    case types.CHANGE_TOP_DISCOUNT_THEME:
    case types.CHANGE_TRENDING_PRODUCT_THEME:
    case types.CHANGE_QUICK_VIEW_FIELD:
      return state.set('isSaveBar', true);

    case types.CHANGE_SAVER_BAR_SETTINGS_FIELD:
      if (action.payload !== undefined) {
        return state.set(action.payload.field, action.payload.value);
      }
      return state.set('isSaveBar', false);
    default:
      return state;
  }
};

export default saveBarReducer;
